import {request} from '@/helpers/apiClient'
import {UPLOAD_IMAGES_CONFIG} from '@/utils/constants/apiConfig/uploadImagesConfig'

export const uploadProductMediaService = ({productId, formData, onUploadProgress}) => {
  return request(UPLOAD_IMAGES_CONFIG.UPLOAD_PRODUCT_MEDIA(productId), {
    formData,
    onUploadProgress,
  })
}

export const deleteProductMediaService = ({productId, displayOrder}) => {
  return request(UPLOAD_IMAGES_CONFIG.DELETE_PRODUCT_MEDIA(productId, displayOrder))
}

export const getSastoken = ({media = [], countryCode}) => {
  return request(
    UPLOAD_IMAGES_CONFIG.GET_MEDIA_UPLOAD_URLS({
      ...(countryCode ? {countryCode} : {}),
    }),
    {
      data: {media},
    }
  )
}

export const updateProductMediaMetadata = ({productId, media = [], countryCode, salesOrg}) => {
  return request(
    UPLOAD_IMAGES_CONFIG.UPDATE_PRODUCT_MEDIA_METADATA(productId, {
      ...(countryCode ? {countryCode} : {}),
      ...(salesOrg ? {salesOrg} : {}),
    }),
    {
      data: {media},
    }
  )
}
